import React, { useState,useRef, useEffect } from 'react';
import {
  TextField,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  MenuItem,
  Box,
  Paper,
  Tab,
  Tabs,
  TextareaAutosize,
} from '@mui/material';
import useApi from '../../api/useApi';
import { ClassTeacherCreate } from '../../api/teacherService';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router';
import { CampaignCreate, CategoryGet, OrgCreate } from '../../api/orgService';
import SubCategorySelect from '../Admin/Consumer/SubCategorySelect';
// import { Form, TextArea } from 'semantic-ui-react'
// import { useNavigationTab } from '../../hooks/useNavigationTab';


const CampaignCreateForm = ({allprojects,setSelected}) => {

  const [allcategories,setAllCategories] = useState([])
  const navigate = useNavigate()
  const [form, setForm] = useState({
    name:"",
    title: '',
    description: '',
    type: '',
    category: '',
    sub_category: '',
  });

  const { user } = useAuth();
  // const navigate=useNavigate()
  // const {customNavigate} = useNavigationTab()

  const { request:createCampaign,data:createCampaignData,error:createCampaignError,isLoading:createCampaignIsLoading}=useApi(CampaignCreate)
  const { request:getCategory,data:getCategoryData,error:getCategoryError,isLoading:getCategoryIsLoading}=useApi(CategoryGet)


  const handleChange = (e) => {
    // setForm({ ...form, [e.target.name]: e.target.value });
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  // const handleFormUrlChange = (e,res) => {
  //   setForm({ ...form, [e.target.name]: res });
  // };

  
 
  useEffect(()=>{
    getCategory()
  },[])

  useEffect(()=>{
    if(getCategoryData?.status===200){
      setAllCategories(getCategoryData?.data?.results)
    }
  },[getCategoryData])

  useEffect(()=>{
    if(createCampaignData){
      if(createCampaignData?.status===201){
        toast.success(`${JSON.stringify(createCampaignData?.statusText)}, successful`,{position: "top-center"});
        navigate("/staff/campaigns/",{state: {redirect:"list-campaigns"}})
      }
    }
  },[createCampaignData])

  useEffect(()=>{
    if(createCampaignError){

        toast.error(`${JSON.stringify(createCampaignError?.response?.data,null,2)}`,{position: "top-center"});
    }
  },[createCampaignError])


  // const firstPart = form?.org_description?.slice(0, 150);
  // const extraPart = form?.org_description?.slice(150);
  const  okayToSubmit =!form?.name?.length===0 || !form?.description?.length===0 || !form.title?.length>0 || !form.description?.length>15 || !form.category

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Material Created:', form);
    form.created_by = user?.user?.id
    const dataToSend = {
      title: form.title,
      description: form.description,
      type: form.type,
      category:form.category,
      name:form.name,
      sub_category: form.sub_category
    }
    createCampaign(dataToSend)

    // Add API request logic here
  };

  const handleSetSubCategoryId = (subcategoryId)=>{
    // console.log(subcategoryId)
    setForm(prev => ({
      ...prev,
      sub_category: parseInt(subcategoryId)
    }));
    // console.log(form)
  }


  const handleSetCategoryId = (categoryId)=>{
    // console.log(subcategoryId)
    setForm(prev => ({
      ...prev,
      category: parseInt(categoryId)
    }));
    // console.log(form)
  }
  return (
    <Box display="flex" justifyContent="center" width="100%">
    <Box display="flex" flexDirection="column" justifyContent="center" mt={4} width={700}>

        <div>
          
          <Typography variant="h5" gutterBottom>
            Create a new Campaign
          </Typography>
        </div>
          
          <Typography variant='p' component="p" color='#404040'>
          A campaign refers to any activity intended to carry continuous awareness and message to the audience in areas the organisation is passionate about.
          </Typography>
          <form onSubmit={handleSubmit} style={{marginTop:30}}>
            
          <i>Required fields are marked with an asterisk (*).</i>
          <TextField
              fullWidth
              label="Campaign Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              margin="normal"
              required
              
            />
            <TextField
              fullWidth
              label="Campaign Title (statement)"
              name="title"
              value={form.title}
              onChange={handleChange}
              margin="normal"
              required
              multiline
              rows={3}
              
            />
            <Typography variant='p' component="p" color='#404040'>
            Write a brief, informative description that explains about the campaign.
            </Typography>

            <TextField
              fullWidth
              label="Campaign Description"
              name="description"
              value={form.description}
              onChange={handleChange}
              margin="normal"
              required
              sx={{ mt: 1 ,mb:3}}
              multiline
              rows={3}
            />
            
            <TextField
              select
              name="type"
              label="Campaign Media Type"
              placeholder="(e.g., Audio, Video, Image)"
              value={form.type}
              onChange={handleChange}
              fullWidth
              sx={{ mt: 1 ,mb:3}}
              required
            >
              <MenuItem value="image">Image</MenuItem>
              <MenuItem value="video">Video</MenuItem>
              <MenuItem value="audio">Audio</MenuItem>
            </TextField>

            {/* <TextField
              select
              name="category"
              label="Campaign Focus Category"
              placeholder="(e.g., Audio, Video, Image)"
              // value={partner.partnership_type}
              onChange={handleChange}
              fullWidth
              sx={{ mt: 1 ,mb:3}}
              required
            > */}
              {/* {
                allcategories?.length>0?(
                allcategories?.map((item,idx)=>(<MenuItem key={idx}value={item.id}>{item.name}</MenuItem>))
                ):(<MenuItem value="none">No category added</MenuItem>)
              } */}
              
              {/* <MenuItem value="video">Income</MenuItem> <MenuItem value="audio">Mothers</MenuItem> */}
            {/* </TextField>  */}

            <SubCategorySelect setSubCategoryId={handleSetSubCategoryId} setCategoryId={handleSetCategoryId}/>

            
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 1 ,mb:5}}
              disabled={okayToSubmit}
            >
              Create Campaign
            </Button>
          </form>
      </Box>
    </Box>
  );
};


export default CampaignCreateForm